import React, { useState, useEffect } from "react";
import { Menu, MenuItem } from "@material-ui/core";
import classNames from "classnames";
import {
  BreadCrumbs,
  NamedLink,
  Notification as NotificationComponent,
} from "../../../components";
import { FormattedMessage, injectIntl } from "../../../utils/reactIntl";

import "./TopbarDesktop.global.scss";
import BrandLockup from "../../BrandLockup";
import userbig from "../../../assets/svg/userbig.svg";
import setting from "../../../assets/svg/settings.svg";
import logout from "../../../assets/svg/logout.svg";
import { connect, useDispatch, useSelector } from "react-redux";
import { getUserUpdatedProfile } from "../../../actions";
import { compose } from "redux";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  className?: string;
  rootClassName?: string;
  isAuthenticated: boolean;
  logoutAction: any;
  userProfile: any;
  getProfileInfo: any;
}

export const TopbarDesktop = (props: Props) => {
  const {
    className,
    rootClassName,
    isAuthenticated,
    logoutAction,
    userProfile,
    getProfileInfo,
  } = props;
  const [accountAnchor, setAccountAnchor] = useState<HTMLElement | null>(null);
  const [mounted, setMounted] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!userProfile.data && !userProfile.loadingInProgress) {
      getProfileInfo();
    }
  }, [userProfile]);

  const handleLogout = () => {
    logoutAction();
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const classes = classNames(rootClassName || 'topbar_root', className);
  const profileMenu = authenticatedOnClientSide ? (
    <p role="presentation" className="logout" onClick={handleLogout}>
      <img src={logout} alt="userprofile" />
      <FormattedMessage id="TopbarDesktop.logout" />
    </p>
  ) : null;

  const loginLink = isAuthenticatedOrJustHydrated ? null : (
    <NamedLink name="LoginPage" className="loginLink">
      <span className="login">
        <FormattedMessage id="TopbarDesktop.login" />
      </span>
    </NamedLink>
  );
  const [showProfileImage, setShowProfileImage] = React.useState(true);
  function pageTiTle() {
    if (location.pathname.includes("/myProfile")) {
      return (
        <NamedLink className="logoLink" name="MyProfile">
          My Profile
        </NamedLink>
      );
    }
    if (location.pathname.includes("/usermanagement")) {
      return (
        <NamedLink className="logoLink" name="UserManagement">
          User Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/channelmanagement")) {
      return (
        <NamedLink className="logoLink" name="ChannelManagement">
          Channel Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/domesmanagement")) {
      return (
        <NamedLink className="logoLink" name="DomesManagement">
          Domes Management
        </NamedLink>
      );
    }

    if (location.pathname.includes("/subdomesmanagement")) {
      return (
        <NamedLink className="logoLink" name="SubDomesManagement">
          Sub Domes Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/rolemanagement")) {
      return (
        <NamedLink className="logoLink" name="RoleManagement">
          Role Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/rewardpoints")) {
      return (
        <NamedLink className="logoLink" name="RewardPointManagement">
          Reward Point
        </NamedLink>
      );
    }
    if (location.pathname.includes("/subadminmanagement")) {
      return (
        <NamedLink className="logoLink" name="SubAdminManagement">
          Sub Admin Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/subadminmanagement")) {
      return (
        <NamedLink className="logoLink" name="SubAdminManagement">
          SubAdmin Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/reportusermanagement")) {
      return (
        <NamedLink className="logoLink" name="ReportUserManagement">
          Report User Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/contentmanagement")) {
      return (
        <NamedLink className="logoLink" name="Settings">
          Content Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/notification")) {
      return (
        <NamedLink className="logoLink" name="Settings">
          Notification Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/settings")) {
      return (
        <NamedLink className="logoLink" name="Settings">
          Settings
        </NamedLink>
      );
    }
    if (location.pathname.includes("/masterreason")) {
      return (
        <NamedLink className="logoLink" name="MasterReason">
          Master Reason Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/livestreaming")) {
      return (
        <NamedLink className="logoLink" name="LiveStreaming">
          Event Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/feedback")) {
      return (
        <NamedLink className="logoLink" name="Feedback">
          Rating(Feedback) Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/versionmanagement")) {
      return (
        <NamedLink className="logoLink" name="VersionManagement">
          Version Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/paymentmanagement")) {
      return (
        <NamedLink className="logoLink" name="PaymentManagement">
          Payment Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/support")) {
      return (
        <NamedLink className="logoLink" name="SupportManagement">
          Support Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/coinactivity")) {
      return (
        <NamedLink className="logoLink" name="CoinActivity">
          Avatcoin Activity Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/ecommerce")) {
      return (
        <NamedLink className="logoLink" name="Ecommerce">
          Purchase & Ecommerce Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/sessionmanagement")) {
      return (
        <NamedLink className="logoLink" name="Session">
          Session Management
        </NamedLink>
      );
    }
    if (location.pathname.includes("/subscribedusers")) {
      return (
        <NamedLink className="logoLink" name="SubscribedUsers">
          Subscribed Users
        </NamedLink>
      );
    }
    if (location.pathname.includes("/entervice")) {
      return (
        <NamedLink className="logoLink" name="EnterVice">
          ENTER VICE
        </NamedLink>
      );
    }
    if (location.pathname.includes("/specialposts")) {
      return (
        <NamedLink className="logoLink" name="SpecialPosts">
          Special Posts
        </NamedLink>
      );
    }
    return "";
  }

  return (
    <nav className={classes}>
      <div className="avatus-breadcrumb">
        <a className="avatus-mobile-brand" href="/" aria-label="AVATUS dashboard"><BrandLockup /></a>
        <span className="avatus-crumb-label">Workspace / </span>
        {location.pathname === "/" ? <span>Dashboard</span> : pageTiTle()}
        <BreadCrumbs location={location} />
      </div>
      <div className="rightSide">
        <NotificationComponent />
        <div className="userInfo">
          <button type="button" className="admin-account-button" aria-label="Account menu"
            aria-haspopup="true" aria-expanded={Boolean(accountAnchor)}
            onClick={(event) => setAccountAnchor(event.currentTarget)}>
            <img className="profile_img" alt="" src={showProfileImage && userProfile.data?.profilePicture ? userProfile.data.profilePicture : userbig}
              onError={() => setShowProfileImage(false)} />
            <h4>{userProfile.data?.name || localStorage.getItem("username")}</h4>
          </button>
          <Menu PaperProps={{ className: "avatus-account-menu" }} anchorEl={accountAnchor} open={Boolean(accountAnchor)} onClose={() => setAccountAnchor(null)}>
            <MenuItem onClick={() => { setAccountAnchor(null); navigate("/myProfile"); }}>My Profile</MenuItem>
            <MenuItem onClick={() => { setAccountAnchor(null); navigate("/settings"); }}>Settings</MenuItem>
            {authenticatedOnClientSide && <MenuItem onClick={() => { setAccountAnchor(null); handleLogout(); }}><FormattedMessage id="TopbarDesktop.logout" /></MenuItem>}
          </Menu>
        </div>
        {loginLink}
      </div>
    </nav>
  );
};

const mapStateToProps = (state: any) => ({
  userProfile: state.updateProfile,
});
const mapDispatchToProps = (dispatch: any) => ({
  getProfileInfo: () => dispatch(getUserUpdatedProfile()),
});

const TopbarDesktopComponent = compose<React.ElementType>(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(TopbarDesktop);

export default TopbarDesktopComponent;
